// extracted by mini-css-extract-plugin
module.exports = {"nav":"UserMenu_nav__3jfHM","navItem":"UserMenu_navItem__NgLdr","active":"UserMenu_active__19uBo"};